import { render, staticRenderFns } from "./provider.vue?vue&type=template&id=13a65244&"
import script from "./provider.vue?vue&type=script&lang=js&"
export * from "./provider.vue?vue&type=script&lang=js&"
import style0 from "./provider.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports